import { useQuery } from '@tanstack/react-query';
import { useNostr } from '@nostrify/react';
import { PLAYLIST_KIND, parsePlaylist } from '@/lib/musicTypes';

export function usePlaylist(pubkey: string, playlistId: string) {
  const { nostr } = useNostr();

  return useQuery({
    queryKey: ['playlist', pubkey, playlistId],
    queryFn: async (c) => {
      const signal = AbortSignal.any([c.signal, AbortSignal.timeout(5000)]);

      const events = await nostr.query(
        [
          {
            kinds: [PLAYLIST_KIND],
            authors: [pubkey],
            '#d': [playlistId],
          },
        ],
        { signal }
      );

      if (events.length === 0) return null;

      return parsePlaylist(events[0]);
    },
  });
}
